import AddUserTemplate from "../../components/templates/user/add";
import LayoutTemplate from "../../components/templates/layout/left";

const AddUser = () => {
    return (
        <LayoutTemplate>
            <AddUserTemplate />
        </LayoutTemplate>
    )
}

export default AddUser;
